<template>
  <div class="page-XLPageBanner">
    <div class="pg">
      <div class="title">
        <h1>{{ title }}</h1>
        <span>{{ entitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XLPageBanner",
  props: {
    title: {
      type: String,
      default: null,
    },
    entitle: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="less" scoped>
.page-XLPageBanner {
  height: 60vh;
  .pg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 60vh;
    background-image: url(../style/img/picture.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      position: absolute;
      right: 20%;
      bottom: 20%;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: flex-end;
      h1 {
        color: #fff;
        font-size: 50px;
      }
      span {
        margin-left: 2%;
        color: #ffffff94;
        font-size: 24px;
      }
      @media (max-width: 960px) {
        h1 {
          font-size: 30px;
        }
        span {
          font-size: 16px;
        }
      }
    }
    @media (max-width: 960px) {
      .title {
        right: 0;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
      }
    }
  }
}
</style>
